import { render, staticRenderFns } from "./compareToLastYear.vue?vue&type=template&id=0be9430b&scoped=true&"
import script from "./compareToLastYear.vue?vue&type=script&lang=js&"
export * from "./compareToLastYear.vue?vue&type=script&lang=js&"
import style0 from "./compareToLastYear.vue?vue&type=style&index=0&id=0be9430b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9430b",
  null
  
)

export default component.exports